import React from "react";
import { ReactSVG } from "react-svg";
import { useEnvContext } from "@gw/env-context";
import { NSSpecies } from "@gw/types";
import { imgs } from "@gw/theming";
import { FarmListNavItemStyled, InnerSection } from "./FarmListNavItemStyled";
import FarmerImage from "../FarmerImage";
var FarmListNavItem = function (_a) {
    var id = _a.id, name = _a.name, image = _a.image, city = _a.city, state = _a.state, species_data = _a.species_data, isActive = _a.isActive, onMouseEnter = _a.onMouseEnter, onMouseLeave = _a.onMouseLeave;
    var imgsFolder = useEnvContext().imgsFolder;
    return (React.createElement(FarmListNavItemStyled, { className: isActive ? "item-active" : "", onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave },
        React.createElement("a", { href: "/directory/detail/" + id, target: "_blank", rel: "noreferrer" },
            React.createElement(InnerSection, { className: "inner-section" },
                React.createElement(FarmerImage, { logoImg: image }),
                React.createElement("div", null,
                    React.createElement("h3", null, name),
                    React.createElement("p", { className: "species" }, species_data
                        .map(function (_a) {
                        var _b;
                        var species = _a.species;
                        return (_b = NSSpecies.labels.speciesLabels.kelp[species]) === null || _b === void 0 ? void 0 : _b.name;
                    })
                        .join(" • ")),
                    city && state && (React.createElement("p", { className: "location" },
                        React.createElement(ReactSVG, { className: "icon-place", src: imgsFolder + "/" + imgs.icons.iconPlaceGreen, wrapper: "span" }), city + ", " + state)))))));
};
export default FarmListNavItem;
//# sourceMappingURL=FarmListNavItem.js.map